
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_1x1rn_97",
  "fit-height": "awsui_fit-height_14iqq_1x1rn_111",
  "with-side-media": "awsui_with-side-media_14iqq_1x1rn_116",
  "variant-default": "awsui_variant-default_14iqq_1x1rn_119",
  "variant-stacked": "awsui_variant-stacked_14iqq_1x1rn_119",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_1x1rn_172",
  "with-top-media": "awsui_with-top-media_14iqq_1x1rn_184",
  "content-wrapper": "awsui_content-wrapper_14iqq_1x1rn_189",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_1x1rn_194",
  "media": "awsui_media_14iqq_1x1rn_199",
  "media-top": "awsui_media-top_14iqq_1x1rn_216",
  "media-side": "awsui_media-side_14iqq_1x1rn_221",
  "header": "awsui_header_14iqq_1x1rn_227",
  "header-with-media": "awsui_header-with-media_14iqq_1x1rn_232",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_1x1rn_238",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_1x1rn_242",
  "header-stuck": "awsui_header-stuck_14iqq_1x1rn_248",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_1x1rn_254",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_1x1rn_257",
  "with-paddings": "awsui_with-paddings_14iqq_1x1rn_263",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_1x1rn_269",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_1x1rn_319",
  "dark-header": "awsui_dark-header_14iqq_1x1rn_337",
  "content": "awsui_content_14iqq_1x1rn_189",
  "content-fit-height": "awsui_content-fit-height_14iqq_1x1rn_345",
  "content-with-media": "awsui_content-with-media_14iqq_1x1rn_354",
  "footer": "awsui_footer_14iqq_1x1rn_358",
  "with-divider": "awsui_with-divider_14iqq_1x1rn_361"
};
  